<template>
  <generic-modal
    :title="$t('module configuration')"
    icon="settings"
    image="/images/icons/configuration.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <generic-container
        icon="key"
        :show_plus="true"
        :title="$t('access management')"
        class="ui basic segment"
        @add="add_user"
      >
        <div class="ui form">
          <div class="fields" v-for="(usr, idx) in users" :key="idx">
            <div class="four wide column field">
              <label for>{{ $t("username") }}</label>
              <input type="text" name="username" v-model="users[idx].username" />
            </div>
            <div class="four wide column field">
              <label for>{{ $t("password") }}</label>
              <input type="text" name="password" v-model="users[idx].password" />
            </div>
            <div class="eight wide column field">
              <label for>{{ $t("options") }}</label>
              <div class="ui mini red icon labeled button" @click="remove_user(usr, idx)">
                <i class="trash icon"></i>
                {{ $t("delete") }}
              </div>
              <div class="ui mini green icon labeled button" @click="save_user(usr, idx)">
                <i class="check icon"></i>
                {{ $t("save") }}
              </div>
            </div>
          </div>
        </div>
        <!-- <pre>{{users}}</pre> -->
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { v4 } from "uuid";

export default {
  name: "ModulManagerConfigureModal",
  components: {
    "generic-modal": GenericModal,
    GenericContainer
  },
  computed: {},
  data() {
    return {
      users: []
    };
  },
  methods: {
    finished() {
      return new Promise(function(resolve) {
        resolve();
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    add_user() {
      this.users.push({ uuid: v4(), username: "", password: "" });
    },
    remove_user(user, index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove user?"), function() {
        local_api(vm, "post", "/api_monitor/do-remove-user", {
          u: user.uuid
        })
          .then(() => {
            vm.users.splice(index, 1);
          })
          .catch(err => {
            vm.$alertify.error(err);
          });
      });
    },
    save_user(user) {
      let vm = this;
      local_api(this, "post", "/api_monitor/do-save-user", user)
        .then(() => {
          vm.$alertify.success(vm.$t("user saved"));
        })
        .catch(err => {
          vm.$alertify.error(err);
        });
    }
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/api_monitor/do-get-users")
      .then(usrs => {
        vm.users = usrs;
      })
      .catch(err => {
        vm.$alertify.error(err);
      });
  },
  watch: {},
  updated: function() {}
};
</script>
